import { ReactNode } from 'react';
import { AppState } from '../../state';
import { DataGridHandler } from './DataGridHandler';
import { Toolbar } from './Toolbar';
import DataGridFlexSalesProvider from './DataGridFlexSalesProvider';
import DataGrid from './DataGrid';

interface DataGridFlexSalesProps<TData, TContext> {
  handlerFactory: (locale: Locale) => DataGridHandler<TData, TContext>;
  children: ReactNode;
  hideToolbar?: boolean;
  hideSummaryRow?: boolean;
  columnChooserDisabledSelector?: (state: AppState) => boolean;
}

const DataGridFlexSales = <TData, TContext>({
  handlerFactory,
  children,
  hideToolbar,
  hideSummaryRow,
  columnChooserDisabledSelector,
}: DataGridFlexSalesProps<TData, TContext>) => (
  <DataGridFlexSalesProvider handlerFactory={handlerFactory}>
    {children}
    {!hideToolbar && <Toolbar columnChooserDisabledSelector={columnChooserDisabledSelector} />}
    <DataGrid showSummaryRow={!hideSummaryRow} />
  </DataGridFlexSalesProvider>
);

export default DataGridFlexSales;
